/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the CoreApiConfiguration configuration object with a given root URL.
 */
export function provideCoreApiConfiguration(rootUrl: string) {
  var config = new CoreApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: CoreApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class CoreApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `O2CoreApiModule.forRoot()`
 */
export interface CoreApiConfigurationParams {
  rootUrl?: string;
}
